import { create, type StoreApi, type UseBoundStore } from 'zustand';
import { persist } from 'zustand/middleware';
import { FilterState } from '../DataTable';

interface DateTableState {
    enabledFilterState: string[];
    setEnabledFilterState: (keys: string[]) => void;
    filterState: FilterState;
    setFilterState: (data: FilterState) => void;
}

type DataTableStore = UseBoundStore<StoreApi<DateTableState>>;

const stores = new Map<string, DataTableStore>();

const createDataTableState = (dataTableKey: string) =>
    create<DateTableState>()(
        persist(
            (set, get) => ({
                enabledFilterState: [],
                setEnabledFilterState: (keys) => set({ ...get(), enabledFilterState: keys }),
                filterState: {},
                setFilterState: (data) => set({ ...get(), filterState: data })
            }),
            {
                name: dataTableKey
            }
        )
    );

const useDataTableState = (dataTableKey: string) => {
    if (!stores.has(dataTableKey)) {
        stores.set(dataTableKey, createDataTableState(dataTableKey));
    }

    return stores.get(dataTableKey)!;
};

export default useDataTableState;
